import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["optionsField", "optionsList", "optionTemplate"]

  connect() {
    this.toggleOptionsField()
  }

  toggleOptionsField() {
    const questionTypeSelect = this.element.querySelector("select[name='question[question_type]']")
    if (!questionTypeSelect) return

    const selectedType = questionTypeSelect.value

    if (this.hasOptionsFieldTarget) {
      if (selectedType === "select_box" || selectedType === "radio") {
        this.optionsFieldTarget.classList.remove("hidden")
      } else {
        this.optionsFieldTarget.classList.add("hidden")
      }
    }
  }

  addOption() {
    if (!this.hasOptionsListTarget) return

    const index = this.optionsListTarget.children.length
    const wrapper = document.createElement("div")
    wrapper.className = "flex items-center gap-2"
    wrapper.innerHTML = `
      <input type="text" name="question[options_list][]"
        class="w-full rounded-xl border border-gray-200 px-4 py-2 text-sm focus:border-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-900/5"
        placeholder="Option ${index + 1}" />
      <button type="button" data-action="question-form#removeOption"
        class="shrink-0 rounded-lg p-1.5 text-gray-400 hover:bg-red-50 hover:text-red-600 transition-colors">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    `
    this.optionsListTarget.appendChild(wrapper)
    wrapper.querySelector("input").focus()
  }

  removeOption(event) {
    const wrapper = event.currentTarget.closest("div")
    if (this.optionsListTarget.children.length > 1) {
      wrapper.remove()
    }
  }
}
